<script>
  import Container from '~/components/ui/container.svelte'
</script>

<section>
  <Container>
    <div
      class="space-y-4 [&_a]:text-brand [&_a]:underline [&_p+p]:mt-4 [&_strong]:text-brand [&_ul]:ps-10"
    >
      <div>
        <h3 class="mb-6 text-2xl font-bold text-black">Política de Privacidade da Lutruvials</h3>

        <p>
          A <strong>Lutruvials</strong> tem um compromisso inabalável com a proteção de dados e privacidade.
          Implementamos os mais altos padrões de segurança para garantir que as informações pessoais
          coletadas sejam utilizadas exclusivamente para os fins contratados, seguindo as melhores práticas
          do mercado e a legislação aplicável.
        </p>

        <p>
          Nossa missão é desenvolver soluções inovadoras e eficientes, sempre priorizando a
          segurança e a experiência do usuário. Por isso, a coleta e o tratamento de dados são
          realizados de forma transparente, ética e em conformidade com a <strong
            >Lei Geral de Proteção de Dados (LGPD)</strong
          > e outros regulamentos pertinentes.
        </p>

        <p>
          Esta <strong>Política de Privacidade ("Política")</strong> tem como objetivo esclarecer
          como coletamos, utilizamos, armazenamos e compartilhamos suas informações, além de
          informar sobre seus direitos como titular de dados. Recomendamos a leitura atenta deste
          documento, que é parte integrante dos <strong>Termos e Condições de Uso</strong> da
          <strong>Lutruvials</strong>.
        </p>
      </div>

      <div>
        <h3 class="font-bold">
          AO UTILIZAR NOSSOS SERVIÇOS, VOCÊ DECLARA ESTAR CIENTE E DE ACORDO COM AS CONDIÇÕES AQUI
          ESTABELECIDAS.
        </h3>

        <p class="mb-4">
          Para facilitar sua compreensão, esta Política está organizada da seguinte forma:
        </p>

        <ul class="list-decimal ps-10 font-medium">
          <li>Quais dados coletamos?</li>
          <li>Como coletamos seus dados?</li>
          <li>Como utilizamos as informações coletadas?</li>
          <li>Com quem compartilhamos seus dados?</li>
          <li>Quais são seus direitos sobre seus dados?</li>
          <li>Como protegemos suas informações?</li>
          <li>Por quanto tempo armazenamos seus dados?</li>
          <li>Atualizações desta Política</li>
          <li>Legislação aplicável e contato</li>
        </ul>
      </div>

      <div>
        <h3 class="font-bold">1. Quais dados coletamos?</h3>
        <p class="mb-4">
          Para prestar nossos serviços com excelência, coletamos os seguintes tipos de informações:
        </p>

        <ul class="[&_p]:font-bold [&_p]:text-brand">
          <li>
            <p>1.1 Dados pessoais</p>
            <ul class="list-disc">
              <li>Nome completo, CPF, RG, data de nascimento, endereço, e-mail e telefone.</li>
              <li>Dados profissionais (cargo, empresa, área de atuação).</li>
            </ul>
          </li>

          <li>
            <p>1.2 Dados técnicos e de uso</p>
            <ul class="list-disc">
              <li>Endereço IP, tipo de navegador, sistema operacional e logs de acesso.</li>
              <li>Cookies e tecnologias similares (consulte nossa Política de Cookies).</li>
            </ul>
          </li>

          <li>
            <p>1.3 Dados de pagamento (se aplicável)</p>
            <ul class="list-disc">
              <li>
                Informações necessárias para processamento de transações (em parceria com gateways
                seguros).
              </li>
            </ul>
          </li>

          <li>
            <p>1.4 Dados de terceiros (com consentimento)</p>
            <ul class="list-disc">
              <li>Integrações com APIs (Google, Microsoft, etc.).</li>
              <li>Dados fornecidos por parceiros comerciais.</li>
            </ul>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-bold">2. Como coletamos seus dados?</h3>
        <p class="mb-4">A coleta pode ocorrer de duas formas:</p>

        <ul class="[&_p]:font-bold [&_p]:text-brand">
          <li>
            <p>2.1 Informações fornecidas por você</p>
            <ul class="list-disc">
              <li>Cadastro em nossas plataformas.</li>
              <li>Preenchimento de formulários.</li>
              <li>Comunicação via e-mail, 'Whatsapp', 'Messager' ou chat de suporte, etc....</li>
            </ul>
          </li>

          <li>
            <p>2.2 Informações coletadas automaticamente</p>
            <ul class="list-disc">
              <li>Dados de navegação (cookies, analytics).</li>
              <li>Interações com nossos sistemas.</li>
            </ul>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-bold">3. Como utilizamos as informações coletadas?</h3>
        <p class="mb-4">Seus dados são utilizados para:</p>

        <ul class="list-disc">
          <li>
            <strong>Prestação de serviços:</strong> Desenvolvimento, manutenção e suporte de softwares.
          </li>
          <li><strong>Segurança:</strong> Prevenção de fraudes e proteção de sistemas.</li>
          <li><strong>Melhoria contínua:</strong> Análise de uso para otimização de produtos.</li>
          <li>
            <strong>Comunicações:</strong> Envio de informações técnicas e comerciais (com opção de opt-out).
          </li>
          <li>
            <strong>Cumprimento legal:</strong> Atendimento a obrigações regulatórias.
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-bold">4. Com quem compatilhamos seus dados?</h3>
        <p class="mb-4">Seus dados podem ser compartilhados com:</p>

        <ul class="list-disc">
          <li>
            <strong>Parceiros e fornecedores</strong> (apenas para fins contratuais).
          </li>
          <li><strong>Autoridades legais</strong> (mediante requisição judicial).</li>
          <li>
            <strong>Empresas do mesmo grupo econômico:</strong> (para otimização de serviços).
          </li>
        </ul>

        <p class="font-bold">Nunca venderemos seus dados pessoas para terceiros.</p>
      </div>

      <div>
        <h3 class="font-bold">5. Quais são seus direitos sobre seus dados?</h3>
        <p class="mb-4">De acordo com a <strong>LGPD</strong>, você pode:</p>

        <ul class="list-disc">
          <li>Acessar, corrigir ou solicitar a exclusão de seus dados.</li>

          <li>Revogar consentimentos a qualquer momento.</li>

          <li>Solicitar portabilidade de dados.</li>

          <li>Opôr-se a tratamento automatizados.</li>
        </ul>

        <p>
          Para exercer seus direitos, entre em contato pelo e-mail:
          <a href="https://mailto:contact@lutruvials.com/">contact@lutruvials.com</a>, por fazer
          coloque no
          <strong
            >título o prefixo 'Politica de privacidade - Pedido de [O que você deseja].'</strong
          >
        </p>
      </div>

      <div>
        <h3 class="font-bold">6. Como protegemos suas informações?</h3>
        <p class="mb-4">Adotamos medidas robustas, incluindo:</p>

        <ul class="list-disc">
          <li>
            <strong>Criptografia avançada</strong> (SSL/TLS).
          </li>

          <li>
            <strong>Controle de acesso restrito</strong>.
          </li>

          <li>
            <strong>Monitoramento contínuo contra ameaças</strong>.
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-bold">7. Por quanto tempo amazenamos seus dados?</h3>
        <p class="mb-4">Seus dados serão mantidos:</p>

        <ul class="list-disc">
          <li>
            <strong>Enquanto necessário</strong> para os fins descritos.
          </li>

          <li>
            <strong>Conforme exigido por lei</strong> (ex.: obrigações fiscais).
          </li>
        </ul>

        <p>
          Após esse perído, serão <strong>analizados, excluídos, anonimizados</strong>
        </p>
      </div>

      <div>
        <h3 class="font-bold">8. Atualizações desta política?</h3>
        <p class="mb-4">
          Podemos atualizar esta Política periodicamente. Alterações significativas serão
          comunicadas por e-mail ou em nosso site:
        </p>
      </div>

      <div>
        <h3 class="font-bold">9. Legislação aplicável e contato?</h3>
        <p class="mb-4">
          Esta política é regida pelas leis do <strong>Brasil</strong>. Em caso de dúvidas, entre em
          contato:
        </p>

        <ul class="list-disc">
          <li>
            <strong>E-mail:</strong>
            <a href="https://mailto:lutruvials@gmail.com/">lutruvials@gmail.com</a>.
          </li>

          <li>
            <strong>Endereço:</strong> Brasil, São Paulo, Parque Macedo.
          </li>
        </ul>
      </div>
    </div>
  </Container>
</section>
